import {
  type GenerateSearchSqlForStreamArgument,
  generateSearchSqlMustache,
  orderByLength,
  SEARCH_RESULT_LABEL_COLUMN_NAME,
  SEARCH_RESULT_VALUE_COLUMN_NAME,
} from './common.ts'

export function generateSearchSqlForSalesforceRecordType({ model, parentModel }: GenerateSearchSqlForStreamArgument) {
  const nameProperty = model.properties.find((x) => x.meta === 'name')
  const labelField = nameProperty?.name ?? 'id'
  // eslint-disable-next-line sonarjs/todo-tag
  const sobjectTypeProperty = model.properties.find((x) => x.write?.sourcePropertyName === 'SobjectType') // TODO: sourceでの判定が必要
  // eslint-disable-next-line sonarjs/todo-tag
  const objectName = parentModel.write?.sourceEntityName // TODO sourceで判定
  if (nameProperty === undefined || sobjectTypeProperty === undefined || objectName === undefined) {
    return
  }

  const searchSql = `SELECT
record_type.id as ${SEARCH_RESULT_VALUE_COLUMN_NAME},
record_type."${labelField}" as ${SEARCH_RESULT_LABEL_COLUMN_NAME}
FROM "${model.name}" as record_type
WHERE ${generateSearchSqlMustache(`"${labelField}"`)}
AND record_type."${sobjectTypeProperty.name}" = '${objectName}'
`
  return {
    sql: orderByLength(searchSql, `record_type."${labelField}"`),
    dependedPropertyNames: [
      {
        streamName: model.name,
        propertyName: nameProperty.name,
      },
      {
        streamName: model.name,
        propertyName: sobjectTypeProperty.name,
      },
    ],
  }
}
